/**
 * Setting listeners for custom events for tracking
 * - Adds event tracking for enquiry mailto link clicks, enquiry button clicks and form submission
 * - Adds event tracking for booking appointment button clicks
 */

document.addEventListener('DOMContentLoaded', function () {
  function handleElementClick(event, eventName) {
    Shopify.analytics.publish(eventName, {
      eventName: eventName,
    });
  }

  function handleFormSubmit(event, eventName) {
    Shopify.analytics.publish(eventName, {
      eventName: eventName,
    });

    const form = event.target;
    if (form) {
      form.submit();
    }
  }

  const mailtoLinks = document.querySelectorAll('a[href^="mailto:enquiries@jessicamccormack.com"]');
  mailtoLinks.forEach((link) => {
    link.addEventListener('click', (event) => handleElementClick(event, 'mailto_link_clicked'));
  });

  const enquiryForm = document.querySelector('[data-track-enquiry-form]');
  if (enquiryForm) {
    enquiryForm.addEventListener('submit', (event) => handleFormSubmit(event, 'make_an_enquiry_submit'));
  }
});
